import * as React from 'react';

interface IEmptyPersonColumnProps {}

const EmptyPersonColumn: React.FunctionComponent<IEmptyPersonColumnProps> = (
  props
) => {
  return (
    <div className="user d-inline-flex align-items-center">
      <div className="user-img">
        <div className="avatar-progress avatar-progress--xs position-relative cursor-pointer">
          <div className="left-0 right-0 top-0 bottom-0 m-auto rounded-circle text-primary font-xs d-inline-flex justify-content-center align-items-center">
            <i className="icon-plus"></i>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyPersonColumn;
